import React from 'react';
import PropTypes from 'prop-types';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

const PostScriptsIndicator = ({postScripts}) => (
    postScripts.length > 0 ? (
        <span>
            <FontAwesomeIcon icon="sign-out-alt" />
        </span>
    ) : null
);

PostScriptsIndicator.propTypes = {
    postScripts: PropTypes.array.isRequired,
};

export default PostScriptsIndicator;
